module.exports = __webpack_public_path__ + "assets/img/jyz-select.0ce7e572.png";